import { Chart } from 'chart.js';
const template = require('./mana-supply.tpl').default;

export default DomClass(template, function() {
	var supply = this.supply || {};

	var graphPoints = this.graphPoints || [0, 3, 6, 9, 12, 15, 18, 21];
	var supplyCurve = supply.supplyCurve || [];
	var demandCurve = supply.demandCurve || [];

	try {
		this.pct50turn = supply.threshold(0.5);
		this.pct85turn = supply.threshold(0.85);
		this.pct100turn = supply.threshold(1);
	} catch (ex) {
		// do nothing.
		console.log(ex);
	}

	var supplyGraph = graphPoints.map(function(turn) { return supplyCurve[turn]; });
	var mins = supplyGraph.map(function(s) { if (s) return s.lower; });
	var maxes = supplyGraph.map(function(s) { if (s) return s.upper; });

	var demandGraph = graphPoints.map(function(turn) { return demandCurve[turn]; });
	var demandMins = demandGraph.map(function(d) { if (d) return d.min; });
	var demandMaxes = demandGraph.map(function(d) { if (d) return d.max; });

	var manasupplydata = {
		labels: graphPoints,
		datasets: [
			{
				backgroundColor: '#080',
				borderColor: '#080',
				data: mins,
				label: 'Land Low Est.',
				yAxisID: 'lands',
				fill: false
			}, {
				backgroundColor: 'rgba(204, 255, 204, 0.33)', // '#cfc',
				borderColor: '#7c7',
				data: maxes,
				label: 'Land Upper Est.',
				yAxisID: 'lands',
				fill: 0
			},
			{
				backgroundColor: '#fcc',
				borderColor: '#fcc',
				data: demandMins,
				label: 'Unplayable Low Est.',
				yAxisID: 'cards',
				fill: false
			},
			{
				backgroundColor: 'rgba(255, 204, 204, 0.33)', //'#fcc',
				borderColor: '#c77',
				data: demandMaxes,
				label: 'Unplayable High Est.',
				yAxisID: 'cards',
				fill: 2
			},
		]
	};

	var ctx = this.manasupplygraph.getContext('2d');
	var manachart = new Chart(ctx, {
		type: 'line',
		data: manasupplydata,
		options: {
			legend: {
				display: false,
			},
			tooltips: {
				/* mode: 'index', */
				intersect: true
			},
			scales: {
				xAxes: [{
						scaleLabel: { display: true, labelString: 'Turn' }
				}],
				yAxes: [{
					scaleLabel: { display: true, labelString: 'Lands'},
					id: 'lands',
					position: 'left'
				},
				{
					scaleLabel: { display: true, labelString: 'Unplayable Cards'},
					id: 'cards',
					position: 'right'
				}]
			}
		}
	});

});
